import ReportContentFromPreview from './ReportContentFromPreview';
import ReportContentModal from './ReportContentModal';
import AutosizeTextarea from './AutosizeTextarea';
import LoadingBounce from './LoadingBounce';
import CustomModal from './CustomModal';
import BasicModal from './BasicModal';
import Checkbox from './Checkbox';
import Radio from './Radio';
import ProgressBar from './ProgressBar';
import LineGauge from './LineGauge';
import AppMain from './AppMain';
import PrimeModal from './PrimeModal';
import LicenceModal from './LicenceModal';
import PreviewVideo from './PreviewVideo';
import ConfirmReportContentModal from './ConfirmReportContentModal';
import ReportContent from './ReportContent';
import Tabs from './Tabs';
import Tab from './Tab';
import QuizResultsCard from './QuizResultsCard';
import QuizOptionsControl from './QuizOptionsControl';
import QuizOptionsListControl from './QuizOptionsListControl';
import QuizHeader from './QuizHeader';
import ContentViewer from './ContentViewer';
import ContentItem from './ContentItem';
import FigureContent from './FigureContent';
import ContentImage from './ContentImage';
import ContentVideo from './ContentVideo';
import QuizOptions from './QuizOptions';
import QuizDescription from './QuizDescription';
import QuizResult from './QuizResult';
import QuizResultStatistics from './QuizResultStatistics';
import QuizAnswerStatistics from './QuizAnswerStatistics';
import QuizTextEntryControl from './QuizTextEntryControl';
import QuizPageTitle from './QuizPageTitle';
import QuizChapterName from './QuizChapterName';
import QuizOXControl from './QuizOXControl';
import Card from './Card';

export const components = {
  ReportContentFromPreview,
  ReportContentModal,
  AutosizeTextarea,
  LoadingBounce,
  CustomModal,
  BasicModal,
  Checkbox,
  Radio,
  ProgressBar,
  LineGauge,
  AppMain,
  PrimeModal,
  LicenceModal,
  PreviewVideo,
  ConfirmReportContentModal,
  ReportContent,
  Tabs,
  Tab,
  QuizResultsCard,
  QuizOptionsControl,
  QuizOptionsListControl,
  QuizHeader,
  ContentViewer,
  ContentItem,
  FigureContent,
  ContentImage,
  ContentVideo,
  QuizOptions,
  QuizDescription,
  QuizResult,
  QuizResultStatistics,
  QuizAnswerStatistics,
  QuizTextEntryControl,
  QuizPageTitle,
  QuizChapterName,
  QuizOXControl,
  Card,
};

export default function install(Vue) {
  Object.keys(components).forEach((name) => {
    Vue.component(name, components[name]);
  });
}
